import React from 'react';
import { connect } from 'react-redux';
import TextField from 'material-ui/TextField';
import Button from 'material-ui/Button';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import { CircularProgress } from 'material-ui/Progress';
import { Link } from 'react-router-dom';
import IntlMessages from 'util/IntlMessages';
import { createNotification } from 'util/util';
import {
  hideMessage,
  showAuthLoader,
  userFacebookSignIn,
  userGithubSignIn,
  userGoogleSignIn,
  userSignUp,
  userTwitterSignIn,
} from 'actions/Auth';
import { signUp } from 'util/user-manager';

class SignUp extends React.Component {

  constructor() {
    super();
    this.state = {
      username: '',
      mobile: '',
      email: '',
      password: '',
    };
    this.signup.bind(this);
  }

  componentDidMount() {
    $('.app-main').toggleClass('bg-wrapper');
  }

  componentWillUnmount() {
    $('.app-main').toggleClass('bg-wrapper');
  }

    // componentDidUpdate() {
    //     if (this.props.showMessage) {
    //         setTimeout(() => {
    //             this.props.hideMessage();
    //         }, 3000);
    //     }
    //     if (this.props.authUser !== null) {
    //         this.props.history.push('/');
    //     }
    // }

    signup = () => {
      signUp(this.state.username, this.state.email, this.state.password, this.state.mobile)
        .then((data) => {
          this.props.history.push('/signin');
          NotificationManager.success('Signup Successful', 'Hey! ' + data.user.username + '. ');
        }, (error) => {
           NotificationManager.error(error.message);
        });
    };

  changeMobileNumberFormat =()=> {
      let newNumber, newNumberFormat;
      if((this.state.mobile).charAt(0) === '0'){
          console.log("char. at 0 " + (this.state.mobile).charAt(0));
          newNumber = (this.state.mobile).slice(1,10);
          newNumberFormat = '+61' + newNumber;
          this.setState({
              mobile: newNumberFormat
          },() => {
              this.validatingMobileNumber(newNumberFormat)
          });
      }

      else {
          this.validatingMobileNumber(this.state.mobile);
      }

  }


  validatingMobileNumber = (mobileNumber) => {
    //   let phoneExpression = /^\({0,1}((0|\+61)(4)){0,1}\){0,1}(\ |-){0,1}[0-9]{2}(\ |-){0,1}[0-9]{2}(\ |-){0,1}[0-9]{1}(\ |-){0,1}[0-9]{3}$/;
      let phoneExpression = /^(?:\+?61|0)[2-478](?:[ -]?[0-9]){8}$/;
      if(mobileNumber !== null || mobileNumber !== ''){
          if(((mobileNumber).match(phoneExpression)&&(mobileNumber).length === 12)){
              this.signup();
          }
          else{
              createNotification('Invalid Mobile number.', 'Error', 'Error');
          }
      }

  }

    render() {
      const {
        username,
        mobile,
        email,
        password,
      } = this.state;
      const { showMessage, loader, alertMessage } = this.props;
      return (<div
        id="signup"
        className="app-login-container d-flex justify-content-center align-items-center animated slideInUpTiny animation-duration-3"
      >
        <div className="app-login-main-content">
          <div className="app-logo-content d-flex align-items-center justify-content-center">
            <a className="logo-lg" href="http://www.symbioticnexus.com/">
              <img
                className="img-responsive w-100"
                src="/assets/images/symbiotic.png"
                alt="Symbiotic"
                title="Symbiotic"
              />
            </a>
          </div>

          <div className="app-login-content">
            <div className="app-login-header">
              <h1 className="text-dark">Sign Up</h1>
            </div>

            <div className="mb-4">
              <h2><IntlMessages id="appModule.createAccount" /></h2>
            </div>

            <div className="app-login-form">
              <form method="post" action="/">
                <TextField
                  type="text"
                  id="username"
                  label="Username"
                  onChange={event => this.setState({ username: event.target.value })}
                  fullWidth
                  defaultValue={this.state.username}
                  margin="normal"
                  className="mt-0 mb-2"
                  required
                />
                <TextField
                  type="tel"
                  id="mobile"
                  label="Mobile Number"
                  onChange={event => this.setState({ mobile: event.target.value })}
                 // onChange={this.validatingMobileNumber}
                  fullWidth
                  defaultValue={mobile}
                  margin="normal"
                  className="mt-0 mb-2"
                  minLength="10"
                  maxLength="12"
                  required
                />
                <TextField
                  type="email"
                  onChange={event => this.setState({ email: event.target.value })}
                  id="email"
                  label={<IntlMessages id="appModule.email" />}
                  fullWidth
                  defaultValue={email}
                  margin="normal"
                  className="mt-0 mb-2"
                  required
                />

                <TextField
                  type="password"
                  onChange={event => this.setState({ password: event.target.value })}
                  id="password"
                  label={<IntlMessages id="appModule.password" />}
                  fullWidth
                  defaultValue={password}
                  margin="normal"
                  className="mt-0 mb-4"
                  required
                />

                <div className="mb-3 d-flex align-items-center justify-content-between">
                  <Button
                    variant="raised"
                    onClick={this.changeMobileNumberFormat}
                    color="primary"
                  >Register
                  </Button>
                  <Link className="link-color" to="/signin">
                    <IntlMessages id="signUp.alreadyMember" />
                  </Link>
                </div>

              </form>
            </div>
          </div>

        </div>

        {
                loader &&
                <div className="loader-view">
                  <CircularProgress />
                </div>
            }
        {showMessage && NotificationManager.error(alertMessage)}
        <NotificationContainer />
      </div>);
    }
}

const mapStateToProps = ({ auth, profileInfo }) => {
  const {
    loader, alertMessage, showMessage, authUser,
  } = auth;
  return {
    loader, alertMessage, showMessage, authUser, cognitoUser: profileInfo.cognitoUser,
  };
};


export default connect(mapStateToProps, {
  userSignUp,
  hideMessage,
  showAuthLoader,
  userFacebookSignIn,
  userGoogleSignIn,
  userGithubSignIn,
  userTwitterSignIn,
})(SignUp);



// WEBPACK FOOTER //
// ./containers/SignUp.js